import React, { forwardRef } from "react";

/**
 * H2 Component
 * Consolidates standard heading 2 styling across modules.
 * Default styles: text-gray text-lg font-semibold md:text-4xl m-0 mb-7 text-center
 */
export const H2 = forwardRef(function H2(
  { children, title, className = "", ...props },
  ref
) {
  return (
    <h2
      ref={ref}
      className={`font-primary text-gray text-subhead md:text-headline leading-headline font-semibold m-0 mb-[21px] text-center ${className}`.trim()}
      {...props}
    >
      {children ?? title}
    </h2>
  );
});

export default H2;
